module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av213-5417684e891aaa397cc561a435cc8576.jpg";